import React, { useState, useEffect } from "react";
import { CursorProvider } from "./providers/CursorContext";
import { HomeProvider } from "./providers/HomeContext";
import { PortfolioProvider } from "./providers/PortfolioContext";
import { ThemeProvider } from "./providers/ThemeContext";
import { HomeScreen } from "./pages/HomeScreen";
import { PortfolioScreen } from "./pages/PortfolioScreen";
import { DetailPortfolioScreen } from "./pages/DetailPortfolioScreen";
import "./index.css";

export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Sync routing on browser popstate (back/forward clicks)
  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const navigate = (path: string) => {
    window.history.pushState({}, "", path);
    setCurrentPath(path);
  };

  const renderPage = () => {
    switch (currentPath) {
      case "/":
        return <HomeScreen onNavigate={navigate} />;
      case "/portfolios":
        return <PortfolioScreen onNavigate={navigate} />;
      case "/detail-portfolio":
        return <DetailPortfolioScreen onNavigate={navigate} />;
      default:
        // Default to home page for unmatched routing
        return <HomeScreen onNavigate={navigate} />;
    }
  };

  return (
    <ThemeProvider>
      <PortfolioProvider>
        <HomeProvider>
          <CursorProvider>
            {renderPage()}
          </CursorProvider>
        </HomeProvider>
      </PortfolioProvider>
    </ThemeProvider>
  );
}

export default App;
